import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useMemo } from "react";

async function fetchVouchers(restaurantIds: string[]): Promise<Record<string, string[]>> {
  if (restaurantIds.length === 0) {
    return {};
  }

  const { data } = await supabase
    .from("restaurant_vouchers")
    .select(`
      restaurant_id,
      voucher_types (
        name
      )
    `)
    .in("restaurant_id", restaurantIds);

  if (!data) return {};

  const vouchersMap: Record<string, string[]> = {};
  data.forEach((v: any) => {
    const restaurantId = v.restaurant_id;
    const voucherName = v.voucher_types?.name;
    if (voucherName) {
      if (!vouchersMap[restaurantId]) {
        vouchersMap[restaurantId] = [];
      }
      vouchersMap[restaurantId].push(voucherName);
    }
  });

  return vouchersMap;
}

export function useRestaurantVouchers(restaurantIds: string[], enabled = true) {
  // Stabil query key
  const idsKey = useMemo(() => restaurantIds.slice().sort().join(","), [restaurantIds]);

  return useQuery({
    queryKey: ["restaurant-vouchers", idsKey],
    queryFn: () => fetchVouchers(restaurantIds),
    enabled: enabled && restaurantIds.length > 0,
    staleTime: 10 * 60 * 1000, // 10 perc - utalványok ritkán változnak
    gcTime: 60 * 60 * 1000, // 1 óra cache
  });
}
